// extracted by mini-css-extract-plugin
export var locationCard = "_i9-0";